'use client';
import { useAuth } from '@/providers/AuthProvider';

/** Returns `{ uid }` when logged in, else `null`. Does not load Firebase by itself. */
export default function useUser() {
    const { uid, authReady, authUser } = useAuth();

    // While restoring a stored session, treat as loading (null) until auth is ready
    // so bookmark/following pages don't flash the "please login" state.
    if (!authReady && authUser) {
        return null;
    }

    return uid ? { uid } : null;
}
